export default __webpack_public_path__ + "static/media/Clandestine Helm.821748e4.jpg";